import { useEffect, useState } from 'react'
import { PageHeader } from '@/components/layout/PageHeader'
import { ThemeToggle } from '@/components/common/ThemeToggle'
import { useAppAuth } from '@/contexts/app-auth.context'
import { Heading } from '@/components/ui/typography'
import { UserProfile } from '@workos-inc/widgets/user-profile'
import { JEV_FLAG } from '@super/shared-types'
import { useFeatureFlag } from '@/hooks/use-feature-flag'

export function UserProfilePage() {
  const { getAccessToken } = useAppAuth()
  const [accessToken, setAccessToken] = useState<string | null>(null)
  // Temporary: confirms node calls dispatch with Jev for this user.
  const { isEnabled } = useFeatureFlag()

  useEffect(() => {
    const fetchToken = async () => {
      const token = await getAccessToken()
      setAccessToken(token)
    }
    fetchToken()
  }, [getAccessToken])

  return (
    <div className="h-full overflow-y-auto mt-16">
      <div className="space-y-6 p-6 pt-0 mt-6">
        <PageHeader title="View and manage your personal information" />

        <div className="bg-card">
          {accessToken ? (
            <UserProfile authToken={accessToken} />
          ) : (
            <div className="p-6">
              <div className="text-center">
                <p className="text-muted-foreground">Loading...</p>
              </div>
            </div>
          )}
        </div>

        <div className="p-6 space-y-3 rt-reset rt-BaseCard rt-Card rt-r-size-2 rt-variant-surface woswidgets-widget">
          <Heading className="mb-4 " variant="card-title">
            Appearance
          </Heading>
          <ThemeToggle />
        </div>

        {isEnabled(JEV_FLAG) && (
          <div className="p-6 space-y-3 rt-reset rt-BaseCard rt-Card rt-r-size-2 rt-variant-surface woswidgets-widget">
            <Heading className="mb-4 " variant="card-title">
              Jev enabled
            </Heading>
            <p className="text-sm text-muted-foreground">
              Node agent calls you start judge events, signals and form answers
              on Jev first, then the language model.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
